import { useState, useEffect } from 'react';

export function createShareLink ({encodedDescription, encodedURL, title, url, whatsapp }) {
    const shareLinks = {
        twitter: `https://twitter.com/intent/tweet?text=${encodedDescription}&url=${encodedURL}`,
        facebook: `https://www.facebook.com/sharer.php?u=${encodedURL}&description=${encodedDescription}&t=${title}`,
        whatsapp: `https://wa.me/?text=${whatsapp}`,
        email: `mailto:?subject=${title}&url=${encodedURL}&body=${encodedDescription}%20${encodedURL}`,
        telegram:`https://telegram.me/share/url?text=${encodedDescription}&url=${encodedURL}`,
    };
    return shareLinks;
}

function generateShareLinkFromWidget (widget, options) {
    const url = options.widgetURL;
    
    return createShareLink({
        encodedDescription: encodeURIComponent(widget?.shareMessage),
        title: encodeURIComponent(widget?.share_banner_text),
        encodedURL: encodeURIComponent(url),
        whatsapp: encodeURIComponent(`${widget?.shareMessage} ${url}`),
        url,
    });
}

function useShareMenu ({ widget, shareMessageUrl }) {
    const [open, setOpen] = useState(false);
    const [anchor, setAnchor] = useState(null);

    function showShareMenu (target) {
        setOpen(true);
        setAnchor(target);
    }

    function closeShareMenu () {
        setOpen(false);
        setAnchor(null);
    }
   
    useEffect(() => {
        if (open === false) {
            setAnchor(null);
            setOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    function getShareObj (newSharable, social) {
        if (newSharable[social]) {
            return newSharable[social];
        }
        return newSharable.twitter;
    }

    function shareWidget (social) {
        const newSharable = generateShareLinkFromWidget(
            widget,
            {
                widgetURL: shareMessageUrl,
            }
        );
        const sh = getShareObj(newSharable, social);
        window.open(sh, '_blank');
    }

    return {
        showShareMenu,
        shareMenuOpen: open,
        shareMenuAnchor: anchor,
        closeShareMenu,
        shareWidget,
    };
}

export default useShareMenu;